<template>
  <div class="i-map">
    <template v-if="isLoading">
      <div class="loading">
        <img src="@/assets/images/loading.svg">
      </div>
    </template>
    <template v-else>
      <iframe
        id="google-map"
        style="border:0"
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        :src="`https://www.google.com/maps/embed/v1/place?key=${key}&q=${placeParameter}`"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { initGoogleAPI } from '@/api/index.js'
import server from '@/api/server.js'

export default {
  name: 'IMap',
  props: {
    lat: {
      type: Number,
      default () {
        return 0
      }
    },
    lng: {
      type: Number,
      default () {
        return 0
      }
    }
  },

  data () {
    return {
      latLng: {
        lat: this.lat || null,
        lng: this.lng || null
      },
      placeParameter: '',
      key: server.googleApiKey,
      isLoading: false
    }
  },

  computed: {
    ...mapGetters([
      'isLocationActive'
    ])
  },

  watch: {
    isLocationActive: {
      async handler (val) {
        if (val) {
          await initGoogleAPI()
          this.latLngToPlaceParameter(this.latLng)
        }
      }
    }
  },

  methods: {
    latLngToPlaceParameter (latLng) {
      this.isLoading = true
      const geocoder = new google.maps.Geocoder()
      geocoder.geocode({
        location: latLng
      }, (results, status) => {
        if (status === 'OK') {
          const { formatted_address: formatAddress, plus_code: plusCode } = results[0]
          this.placeParameter = formatAddress || plusCode.global_code
        }
        this.isLoading = false
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'
@import '~css/common/extends'

.i-map {
  padding-top: 20px
  height: 100%
  z-index: 1
}

#google-map {
  @extend .full
}

.i-map, #google-map {
  position: relative
  width: 100%
}

.loading {
  display: flex
  justify-content: center
  height: 100px
}

@media (min-width: $response) {
  .i-map {
    padding-top: 30px
  }
}
</style>
